import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {TextField, CheckBoxField} from 'components/Fields';
import Warning from 'components/Warning';

import {nonRequiredPositiveInteger} from 'utils/validators';

import {MODALS, setInactivityLogoutTimer} from 'ducks/teams';
import {selectModal} from 'ducks/modals';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  if (_.isEmpty(values.inactivityTimer)) {
    values = {...values, inactivityTimer: null};
  }

  const data = {teamId: props.teamId, ...values};

  dispatch(setInactivityLogoutTimer(data, props.modalExtraActions));
};

class SetInactivityLogoutForm extends React.Component<any> {
  render() {
    return (
      <form
        className="SetInactivityLogoutForm"
        onSubmit={this.props.handleSubmit}>
        <FormField>
          <Label>Logout After</Label>
          <Field
            className="inactivityTimer"
            name="inactivityTimer"
            validate={[nonRequiredPositiveInteger]}
            placeholder="In minutes"
            component={TextField}
          />
        </FormField>
        {this.props.inactivityTimerValue && (
          <React.Fragment>
            {this.props.forceLogoutValue && (
              <Warning>
                Selecting this checkbox will force all logged team members to be
                logged-out!
              </Warning>
            )}
            <FormField className="forceLogout">
              <Field
                className="forceLogout"
                name="forceLogout"
                label="Log-out all team members"
                component={CheckBoxField}
              />
            </FormField>
          </React.Fragment>
        )}
      </form>
    );
  }
}

const formSelector = formValueSelector('setInactivityLogout');

const mapStateToProps = state => {
  const {data: {team: {inactivityLogoutTimer}}} = selectModal(
    state,
    MODALS.TEAM_DETAILS
  );

  return {
    initialValues: {
      inactivityTimer: inactivityLogoutTimer,
      forceLogout: false
    },
    inactivityTimerValue: formSelector(state, 'inactivityTimer'),
    forceLogoutValue: formSelector(state, 'forceLogout')
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'setInactivityLogout',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(SetInactivityLogoutForm)
);
